import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from 'moment';

var CurrentUser = require("lib/account/CurrentUser");
var StudentMetrics = require("lib/data/StudentMetrics");

var Features = require("lib/account/Features");
var Glyphicon = require("components/utility/icons/Glyphicon");
var ReactTooltip = require("react-tooltip");
var ParentEmailsModal = require("components/org/roster/ParentEmailsModal");
var DocumentClient = require("lib/web/DocumentClient");
var AltModal = require("components/utility/AltModal");
var ProgressBar = require("components/utility/ProgressBar");
var PaywallModal = require("components/users/teachers/PaywallModal");

var DateSpans = require("lib/data/DateSpans");
var DateSpanSelector = require("components/data/DateSpanSelector");
var DropDownOptions = require("components/utility/DropDownOptions");

var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var ButtonDropdown = require("components/utility/ButtonDropdown");
var EmptyStateContainer = require("components/utility/EmptyStateContainer");
var HelpSectionLink = require("components/utility/HelpSectionLink");
var ReadingLevelFormat = require("lib/academic/ReadingLevelFormat");
var ReadingLevelIcon = require("components/reading/reading_levels/ReadingLevelIcon");

var StudentAvatar = require("components/avatars/StudentAvatar");

var DataRouting = require("lib/routing/DataRouting");
var RosterRouting = require("lib/routing/RosterRouting");

var UIActions = require("lib/actions/UIActions");
var UserAlertsActions = require("lib/actions/UserAlertsActions");
var RosterActions = require("lib/actions/RosterActions");

var RosterSelectors = require('lib/selectors/RosterSelectors');
var DataSelectors = require('lib/selectors/DataSelectors');
var StudentListDisplay = require("components/org/student_lists/StudentListDisplay");

require("data/goals_table.scss");

@connect(
	(state, props) => ({
		userIsSchoolAdmin: CurrentUser.isSchoolAdmin(),
		userIsTeacherAdmin: CurrentUser.isTeacherAdmin(),
		students: RosterSelectors.students({
			state, conditions: { ids: props.digests.map((x) => x.student_id) }
		}),
		expectationMetrics: DataSelectors.expectationsMetrics({
			state,
			student_ids: props.userIDs || null,
			student_list_ids: props.studentList ? [parseInt(props.studentList)] : null
		}),
		expectationDigestKeys: StudentMetrics.getDigestEmbeds(DataSelectors.expectationsMetrics({ state })).split(","),
		userMetricsColumns: DataSelectors.dashboardOtherMetrics({}),
		userPrefs: CurrentUser.get().prefs,
		isDisabledMetric: (x) => Features.anyDisabled(StudentMetrics.getFeatureDependencies(x))
	}),
	(dispatch, props) => {
		return {
			createUserAlert: ({ userAlertData }) =>
				dispatch(UserAlertsActions.createUserAlert({ userAlertData })),
			showHistoricalDataPaywall: () =>
				dispatch(UIActions.showPaywall({ paywall: PaywallModal.TEACHER_DASHBOARD })),
			updateDashboardColumns: (newCols) =>
				dispatch(
					RosterActions.updateAdmin({
						id: CurrentUser.get().id,
						update: { prefs: { dashboard_columns: newCols } },
					}),
				).then(() => {
					const prefs = { ...CurrentUser.get().prefs, dashboard_columns: newCols };
					CurrentUser.updateLocal({ prefs });
				}),
		};
	}
)
class GoalsTable extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { orderBy: STUDENT_NAME_ORDER };
	}

	tooltipDate(dateString) {
		var arr = dateString.split('-')
		return `${arr[1]}/${arr[2]}/${arr[0]}`
	}

	changeSortBy(orderBy) {
		this.setState({ orderBy });
	}

	expandStudent(student) {
		$wr.redirect(
			DataRouting.getPath({
				subjectType: DataRouting.SUBJECT_BOOKS,
				userIDs: [student.id],
				startDate: this.props.startDate,
				endDate: this.props.endDate,
			}),
		);
	}

	selectExtraColumn(extraColumnIndex, columnKey) {
		var newDashboardColumns = _.clone(this.props.userMetricsColumns);
		newDashboardColumns[extraColumnIndex] = columnKey;

		newDashboardColumns = _.uniq(_.compact(newDashboardColumns))
		
		if (_.isEqual(this.props.userMetricsColumns, newDashboardColumns)) {
			return;
		}

		this.props.updateDashboardColumns(newDashboardColumns).then(() => {
			return this.props.reloadF()
		});
	}

	stateCellWidth() {
		return ((100 - 25) / this.activeColumns().length) + "%";
	}

	getExpectation(columnName, student) {
		if (student && student.prefs) {
			var grade_level = student && student.grade_level ? student.grade_level : 5
			var expectations = student.prefs.grade_level_expectations_metrics[grade_level]
			var expectedData = _.findWhere(expectations, { metric: columnName });
			if (expectedData) {
				return expectedData.goal;
			}
		}

		// We should have blocked getting here w/ isExpection(columnName, studnet)
		return undefined;
	}

	activeColumns() {
		if (this.props.showGoals) {
			return this.props.expectationMetrics;
		} else {
			return this.props.userMetricsColumns;
		}
	}

	digest(studentID) {
		var start_date = $wr.getURLParameterByName("start_date")
		if (start_date) {
			return _.findWhere(this.props.digests, { student_id: studentID, start_date: start_date});
		}
	

		return _.findWhere(this.props.digests, { student_id: studentID });
	}

	renderReadingVerificationCell(student, readAmount, verifiedAmount, goal) {
		if (readAmount > 0) {
			if (!student.has_parent) {
				var approvalMessage = "Not approved. Click to add parent email for approval.";
				var approvalIcon = <Glyphicon icon="remove-circle" dataTip={approvalMessage} />;
			} else if (verifiedAmount == readAmount) {
				var approvalMessage = "Approved.";
				var approvalIcon = <Glyphicon icon="ok-circle" dataTip={approvalMessage} />;
			} else {
				var approvalMessage = "Not yet approved. Click to edit parent email.";
				var approvalIcon = <Glyphicon icon="question-sign" dataTip={approvalMessage} />;
			}
		} else {
			if (!student.has_parent) {
				var approvalMessage = "Click to add parent email for approval.";
				var approvalIcon = <Glyphicon icon="question-sign" dataTip={approvalMessage} />;
			} else {
				var approvalMessage = "Parent email added.";
				var approvalIcon = <Glyphicon icon="ok" dataTip={approvalMessage} />;
			}
		}

		if (goal == undefined) {
			var readingContent = <span>{readAmount}</span>;
		} else {
			var readingContent = (
				<span>
					{readAmount}/{goal}
				</span>
			);
		}

		if (this.props.userIsTeacherAdmin) {
			var cellContent = (
				<span
					className="parentLink"
					onClick={ (e) => { e.stopPropagation(); $wr.redirect("/student_parents") } }
				>
					{readingContent} {approvalIcon}
				</span>
			);
		} else {
			var cellContent = <p>{readingContent}</p>;
		}
		return (
			<span>
				{cellContent}
				<ReactTooltip effect="solid" />
			</span>
		);
	}

	renderExpectationCellContent(student, col) {
		var goal = this.getExpectation(col, student);
		var digest = this.digest(student.id);
		if (col == "minutes") {
			return this.renderReadingVerificationCell(
				student,
				digest ? digest.minutes_read : 0,
				digest ? digest.verified_minutes_read : 0,
				goal,
			);
		} else if (col == "pages") {
			return this.renderReadingVerificationCell(
				student,
				digest ? digest.pages_read : 0,
				digest ? digest.verified_pages_read : 0,
				goal,
			);
		} else {
			return (
				<span>
					{digest ? StudentMetrics.getValue(digest, col) : 0}/
					{this.getExpectation(col, student)}
				</span>
			);
		}
	}

	renderReadingLevelCell(student, readingLevel) {
		if (readingLevel === undefined) {
			return <span />;
		} else if (readingLevel.indexOf("Incomplete:") >= 0) {
			var progress = _.last(readingLevel.split(":") || "-").trim();
			var tip = progress + " progress toward initial reading level assessment";
			return (
				<span className="readingLevel">
					{readingLevel} <Glyphicon icon="question-sign" dataTip={tip} />
				</span>
			);
		} else if (this.props.userPrefs.reading_levels_hidden) {
			return (
				<span>
					<a href="#" onClick={this.openShowReadlingLevels}>
						Complete
					</a>
				</span>
			);
		} else {
			var scoreFormat = this.props.userPrefs.reading_level_format;
			var formattedReadingLevel = ReadingLevelFormat.getScoreForFormat(
				parseInt(readingLevel),
				scoreFormat,
			);
			var displayLevel = formattedReadingLevel;
			return <span>{displayLevel}</span>;
		}
	}

	renderAcadmicLevelCell(student, academicLevel) {
		var editPath = "/roster/" + RosterRouting.VIEWS.LEVELS;
		var onClick = e => {
			$wr.nope(e);
			e.stopPropagation();
			$wr.redirect(editPath);
		};

		return (
			<span>
				{academicLevel}{" "}
				<a className="editStudent" href="#" onClick={onClick}>
					Edit
				</a>
			</span>
		);
	}

	renderZPDCountsCell(student, counts) {
		counts = counts || {};
		return (
			<span className="zpdCounts">
				<span className="levelStat">
					<ReadingLevelIcon
						tooltipCopyType={ ReadingLevelIcon.COLLECTIVE_VIEW }
						showImageOnly
						status={ ReadingLevelIcon.EASY }
					/>{" "}
					{ counts ? counts.under : "-"}
				</span>
				<span className="levelStat">
					<ReadingLevelIcon
						tooltipCopyType={ ReadingLevelIcon.COLLECTIVE_VIEW }
						showImageOnly
						status={ ReadingLevelIcon.ON_LEVEL }
					/>{" "}
					{ counts ? counts.at : "-" }
				</span>
				<span className="levelStat">
					<ReadingLevelIcon
						tooltipCopyType={ ReadingLevelIcon.COLLECTIVE_VIEW }
						showImageOnly
						status={ ReadingLevelIcon.HARD }
					/>{" "}
					{ counts ? counts.over  : "-"}
				</span>
			</span>
		);
	}

	renderExtraCellContent(student, col) {
		var digest = this.digest(student.id);
		if (
			_.include(
				[
					StudentMetrics.QUIZZES_OPTIONS.LAST_QUIZ,
					StudentMetrics.READING_OPTIONS.LAST_TEXT,
				],
				col,
			)
		) {
			return (
				<em className="longContent">
					{ StudentMetrics.getValue(digest, col) }
				</em>
			);

		} else if (col == StudentMetrics.READING_OPTIONS.MINUTES) {
			return this.renderReadingVerificationCell(
				student,
				digest ? digest.minutes_read : 0,
				digest ? digest.verified_minutes_read : 0,
			);

		} else if (col == StudentMetrics.READING_OPTIONS.PAGES) {
			return this.renderReadingVerificationCell(
				student,
				digest ? digest.pages_read : 0,
				digest ? digest.verified_pages_read : 0,
			);

		} else if (col == StudentMetrics.OTHER_OPTIONS.TOTAL_READER_LEVEL) {
			if (Features.isEnabled(Features.CLOZE_ASSESSMENTS)) {
				return this.renderReadingLevelCell(student, (digest ? digest.total_reader_level : "") + "");
			} else {
				return this.renderReadingLevelCell(
					student,
					(digest ? digest.current_reading_level : "") + "",
				);
			}
		
		} else if (col == StudentMetrics.OTHER_OPTIONS.ACADEMIC_LEVEL) {
			return this.renderAcadmicLevelCell(student, digest.academic_level);
		
		} else if (col == StudentMetrics.QUIZZES_OPTIONS.ZPD_COUNTS) {
			return this.renderZPDCountsCell(student, digest.zpd_counts);
		
		} else {
			return <span>{digest ? StudentMetrics.getValue(digest, col) : ""}</span>;
		}
	}

	renderSortControl() {
		var orderOptionText = (op) => {
			if (STUDENT_NAME_ORDER === op) {
				return "Student Name";
			} else if (LAST_ACTIVE === op) {
				return "Last Activity";
			} else {
				return StudentMetrics.getLabel(op);
			}
		}

		var renderOption = (op) => {
			return (
				<ButtonDropdownOption key={ op } className=""
					text={ orderOptionText(op) }
					onClick={ this.changeSortBy.bind(this, op) }>
				</ButtonDropdownOption>
			);
		}

		var orderOptions = [];

		orderOptions.push(renderOption(STUDENT_NAME_ORDER));
		orderOptions.push(renderOption(LAST_ACTIVE));

		if (this.props.showGoals) {
		_.each(this.props.expectationMetrics, (metric) => {
				orderOptions.push(renderOption(metric));
			});

		} else {			
			_.each(this.props.userMetricsColumns, (metric) => {
				orderOptions.push(renderOption(metric));
			});
		}

		var displayText = orderOptionText(this.state.orderBy);

		return (
			<ButtonDropdown dropdownDisplay="link" text={ displayText }>
				{ orderOptions }
			</ButtonDropdown>
		);
	}

	renderMetricOptions(metrics, extraColIndex) {
		metrics = _.reject(metrics, (m) => {
			return this.props.isDisabledMetric(m) || _.contains(this.props.userMetricsColumns, m);
		})
		return metrics.map((columnKey) => {
			return (
				<ButtonDropdownOption
					onClick={this.selectExtraColumn.bind(
						this,
						extraColIndex,
						columnKey,
					)}
					text={StudentMetrics.getLabel(columnKey)}
					key={columnKey}
				/>
			);
		})
	}

	renderTotalRow() {
		if (!this.props.showTotals) {
			return;
		}

		var statCells = _.map(this.activeColumns(), (col) => {
			if (StudentMetrics.getType(col) == "numeric") {
				var total = 0;

				_.each(this.props.students, student => {
					var digest = this.digest(student.id);
					var value = digest ?  StudentMetrics.getValue(digest, col) : 0;

					if (value != undefined && value != "-") {
						total += value;
					}
				});

			} else {
				var total = "-"
			}

			return (
				<div className="statSection dataCell" key={ col }
					style={{ width: this.stateCellWidth() }}>

					{ total }
				</div>
			);
		});


		return (
			<div className="studentRow dataRow">
				<div className="rowContent">
					<div className="infoSection dataCell">
						Total
					</div>
					{ statCells }
				</div>
			</div>
		);

	}

	renderTableHeaders() {
		// Index of this extra column (which are all on the right)
		var extraColIndex = 0;

		var headerCells = _.map(this.activeColumns(), (col) => {
			var colClassName = "statSection";

			if (this.props.showGoals) {
				var headerText = StudentMetrics.getLabel(col);
				var cellContents = (
					<div className="columnHeaderText">
						{ headerText }
					</div>
				);
				var sortLink = (
					<div className="infoSection studentNameHeader sortControlCell hideOnPrint">
						Sort By: { this.renderSortControl() }
					</div>
				)
			} else {

				var cellContents = (
					<ButtonDropdown dropdownDisplay="link" text={StudentMetrics.getLabel(col)}>
						<li className="dropdown-header">Quizzes</li>
						{ this.renderMetricOptions(StudentMetrics.quizMetrics(), extraColIndex) }

						<li className="dropdown-header">Writing</li>
						{ this.renderMetricOptions(StudentMetrics.writingMetrics(), extraColIndex) }

						<li className="dropdown-header">Reading</li>
						{ this.renderMetricOptions(StudentMetrics.readingMetrics(), extraColIndex) }

						<li className="dropdown-header">Stats</li>
						{ this.renderMetricOptions(StudentMetrics.otherMetrics(), extraColIndex) }
					</ButtonDropdown>
				);

				extraColIndex += 1;
			}
			return (
				<div className="statSection" key={ col } style={{ width: this.stateCellWidth() }}>
					{ cellContents }
				</div>
			);
		});

		if (this.props.showTotals) {
			var sortLink = (
				<div className="infoSection studentNameHeader sortControlCell hideOnPrint">
					Sort By: { this.renderSortControl() }
				</div>
			)
		} else {
			var sortLink = (
				<div className="infoSection studentNameHeader sortControlCell hideOnPrint">
				</div>
			)
		}

		return (
			<div className="studentRow headerRow">
				<div className="rowContent">
					{ sortLink }
					{ headerCells }
				</div>
			</div>
		);
	}

	renderStudentRows() {
		var digestsBySums = _.sortBy(this.props.digests, (digest) => {
			var sum = 0;
			for (var i = 0; i <= this.props.expectationDigestKeys.length - 1; i++) {
				sum += digest[this.props.expectationDigestKeys[i]]
			}
			return sum;
		})

		var orderBy = this.props.sortByResults || this.state.orderBy;


		if (orderBy == LAST_ACTIVE) {
			var students = _.sortBy(this.props.students, (student) => {
				return student.last_active || "1970-01-01";
			}).reverse()

		} else if (orderBy == TOP_RESULTS) {
			var students = _.map(digestsBySums, (digest) => {
				return _.findWhere(this.props.students, { id: digest.student_id })
			}).reverse()

		} else if (orderBy == BOTTOM_RESULTS) {
			var students = _.map(digestsBySums, (digest) => {
				return _.findWhere(this.props.students, { id: digest.student_id })
			})

		} else if (StudentMetrics.isMetric(orderBy)) {
			var digestKey = StudentMetrics.getDigestEmbeds([orderBy]).split(",")[0];

			var toDigest = (s) => {
				var val = this.digest(s.id)[digestKey];
				return val === "-" ? undefined : val;
			}

			var hasValue = _.sortBy(_.select(this.props.students, toDigest), toDigest).reverse();
			var hasNoValue = _.reject(this.props.students, toDigest);

			var students = hasValue.concat(hasNoValue);

		} else {
			var students = $wr.sortByName(this.props.students, "flexName");
		}

		if (this.props.studentLimit) {
			var students = _.first(students, this.props.studentLimit)
		} else {
			if (!this.props.showFullData) {
				var students = _.first(students, 3)
			}
		}

		var activeColumns = this.activeColumns();

		var studentRows = students.map((student) => {
			var digest = this.digest(student.id);

			var statCells = _.map(activeColumns, (col) => {
				var value = digest ? StudentMetrics.getValue(digest, col) : 0;

				if (this.props.showGoals) {
					var goal = this.getExpectation(col, student);

					return (
						<div className="statSection dataCell" key={ col }
							style={{ width: this.stateCellWidth() }}>

							<div>
								{ this.renderExpectationCellContent(student, col) }
							</div>
							<ProgressBar current={ value } total={ goal } />
						</div>
					);
				} else {
					return (
						<div className="statSection dataCell" key={ col }
							style={{ width: this.stateCellWidth() }}>

							{ this.renderExtraCellContent(student, col) }
						</div>
					);
				}
			});

			var cursorClass = "studentRow dataRow clickableElement";
			
			return (
				<div className={ cursorClass } key={ student.id }
					onClick={ this.expandStudent.bind(this, student) }>
					<div className="rowContent">
						<div className="infoSection dataCell">
							<div className="avatarBox hideOnPrint">
								<StudentAvatar disableAnimation student={student} maxWidth={30} />
							</div>
							<div className="infoSection studentName ellipsisText">
								{ student.display_name }
								<StudentListDisplay studentID={ student.id } />
							</div>
						</div>
						{ statCells }
					</div>
				</div>
			);
		});


		return (
			<div>
				{ studentRows }
			</div>
		);
	}

	render() {
		var innerClassName = "innerTable";

		return (
			<div className="goalsTable">
				<div className={ innerClassName }>
					{ this.renderTableHeaders() }
					{ this.renderStudentRows() }
					{ this.renderTotalRow() }
				</div>
			</div>
		);
	}
}

var LAST_ACTIVE = "last-active";
GoalsTable.LAST_ACTIVE = LAST_ACTIVE;

var TOP_RESULTS = "top-results";
GoalsTable.TOP_RESULTS = TOP_RESULTS;

var BOTTOM_RESULTS = "bottom-results";
GoalsTable.BOTTOM_RESULTS = BOTTOM_RESULTS;

var STUDENT_NAME_ORDER = "student-name";

GoalsTable.WrappedComponent.propTypes = StrictPropTypes({
	digests: PropTypes.array.isRequired,
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	showGoals: PropTypes.bool,
	showFullData: PropTypes.bool,
	userPrefs: PropTypes.object,
	reloadF: PropTypes.func,
	sortByResults: PropTypes.string,
	studentLimit: PropTypes.number,
	showTotals: PropTypes.bool,
	studentList: PropTypes.string,
	userIDs: PropTypes.array,

	// Data / fetchers from @connect
	userIsSchoolAdmin: PropTypes.bool,
	userIsTeacherAdmin: PropTypes.bool,
	students: PropTypes.array,
	expectationMetrics: PropTypes.array,
	userMetricsColumns: PropTypes.array,
	expectationDigestKeys: PropTypes.array,
	isDisabledMetric: PropTypes.func,

	// Handlers from @connect
	showHistoricalDataPaywall: PropTypes.func,
	updateDashboardColumns: PropTypes.func,
	createUserAlert: PropTypes.func,

});

const COLUMN_COUNT = 4;

module.exports = GoalsTable;



// WEBPACK FOOTER //
// ./modules/components/data/GoalsTable.js